"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Controller = void 0;
/**
 * Activity indicator controller
 * @public
 */
class Controller {
    /**
     * Initialization
     * @public
     */
    constructor() {
        /**
         * DOM node
         * @public
         */
        this.node = null;
        /**
         * Active WHM payload
         * @public
         */
        this.payload = null;
        this.node = document.createElement('bud-activity-indicator');
        document.body && document.body.appendChild(this.node);
        this.update = this.update.bind(this);
    }
    /**
     * Update activity indicator
     * @public
     */
    update(payload) {
        var _a, _b;
        this.node.payload = payload;
        this.node.setAttribute('has-warnings', (_a = payload.errors) === null || _a === void 0 ? void 0 : _a.length);
        this.node.setAttribute('has-errors', (_b = payload.warnings) === null || _b === void 0 ? void 0 : _b.length);
    }
}
exports.Controller = Controller;
//# sourceMappingURL=indicator.controller.cjs.map